'use client';

import { Box, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import { IconSvg } from '../Icon';
import FinancialSummary from '../financial/FinancialSummary';
import { PdpInfoDTO } from '@/types/models';
interface InvestmentOverviewProps {
  data: PdpInfoDTO;
  hasDetail?: boolean;
}
const text = {
  profitTitle: 'پیش‌بینی سود',
  guarantyTitle: '',
  prePercentValue: 'درصد',
  noProfitGuarantee: '(بدون تضمین سود)',
  guaranteeMainCapital: 'تضمین اصل سرمایه'
};
const InvestmentOverview = ({
  data,
  hasDetail = true
}: InvestmentOverviewProps) => {
  return <Stack sx={{
    width: '100%'
  }} data-sentry-element="Stack" data-sentry-component="InvestmentOverview" data-sentry-source-file="InvestmentOverview.tsx">
      {hasDetail && <Typography sx={{
      height: '80px',
      p: 'var(--spacing_m)'
    }} variant='bodyLargeStrong__Wallfund'>
          {data.title}
        </Typography>}
      <Stack sx={{
      flexDirection: 'row',
      width: '100%',
      alignItems: 'center',
      px: 'var(--spacing_m)',
      bgcolor: 'primaryBrand.bg5',
      justifyContent: 'space-between',
      borderBottom: '1px solid',
      borderColor: 'stroke.stroke2',
      minHeight: 62
    }} data-sentry-element="Stack" data-sentry-source-file="InvestmentOverview.tsx">
        <Stack alignItems='flex-end' data-sentry-element="Stack" data-sentry-source-file="InvestmentOverview.tsx">
          <Stack sx={{
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 'var(--spacing_xs)'
        }} data-sentry-element="Stack" data-sentry-source-file="InvestmentOverview.tsx">
            <IconSvg component={'Profit'} width={21} height={21} viewBox='0 0 40 40' data-sentry-element="IconSvg" data-sentry-source-file="InvestmentOverview.tsx" />
            <Typography variant='bodyStrong__Wallfund' color='primaryBrand.text' data-sentry-element="Typography" data-sentry-source-file="InvestmentOverview.tsx">
              {text.profitTitle}
            </Typography>
          </Stack>
          <Typography variant='caption' color='primaryBrand.text' data-sentry-element="Typography" data-sentry-source-file="InvestmentOverview.tsx">
            {text.noProfitGuarantee}
          </Typography>
        </Stack>

        <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--spacing_xs)',
        borderRadius: 'var(--corner_radius_m)'
      }} data-sentry-element="Box" data-sentry-source-file="InvestmentOverview.tsx">
          <Typography variant='titleStrong__Wallfund' color='primaryBrand.text' data-sentry-element="Typography" data-sentry-source-file="InvestmentOverview.tsx">
            {data.fixedProfit}
          </Typography>
          <Typography variant='bodyRegular__Wallfund' color='text.text2' data-sentry-element="Typography" data-sentry-source-file="InvestmentOverview.tsx">
            {text.prePercentValue}
          </Typography>
        </Box>
      </Stack>
      <Stack sx={{
      flexDirection: 'row',
      width: '100%',
      alignItems: 'center',
      px: 'var(--spacing_m)',
      py: 'var(--spacing_s)',
      bgcolor: 'approve.bg4',
      justifyContent: 'space-between',
      minHeight: 60
    }} data-sentry-element="Stack" data-sentry-source-file="InvestmentOverview.tsx">
        <Stack sx={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 'var(--spacing_xs)',
        width: '100%'
      }} data-sentry-element="Stack" data-sentry-source-file="InvestmentOverview.tsx">
          <Stack sx={{
          flexDirection: 'row',
          gap: 'var(--spacing_xs)'
        }} data-sentry-element="Stack" data-sentry-source-file="InvestmentOverview.tsx">
            <IconSvg component={'Guarantee'} width={21} height={21} viewBox='0 0 40 40' data-sentry-element="IconSvg" data-sentry-source-file="InvestmentOverview.tsx" />
            <Stack data-sentry-element="Stack" data-sentry-source-file="InvestmentOverview.tsx">
              <Typography variant='bodyStrong__Wallfund' color='approve.text' sx={{
              maxWidth: 250,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }} title={data?.guarantee?.title} data-sentry-element="Typography" data-sentry-source-file="InvestmentOverview.tsx">
                {data?.guarantee?.title}
              </Typography>

              <Typography variant='caption' color='approve.text' data-sentry-element="Typography" data-sentry-source-file="InvestmentOverview.tsx">
                {text.guaranteeMainCapital}
              </Typography>
            </Stack>
          </Stack>

          {data.guarantee?.logo?.url && <Stack sx={{
          alignItems: 'center',
          height: 'fit-content'
        }}>
              <Image src={data.guarantee?.logo?.url || ''} height={24} width={76} sizes='100vw' style={{
            width: 'auto',
            height: 'auto',
            maxHeight: 22
          }} alt={data.guarantee?.title || ''} />
            </Stack>}
        </Stack>
      </Stack>
      <Stack sx={{
      width: '100%',
      px: 'var(--spacing_m)',
      py: 'var(--spacing_s)',
      minHeight: 60
    }} data-sentry-element="Stack" data-sentry-source-file="InvestmentOverview.tsx">
        <FinancialSummary data={data} hasDetail={hasDetail} data-sentry-element="FinancialSummary" data-sentry-source-file="InvestmentOverview.tsx" />{' '}
      </Stack>
    </Stack>;
};
export default InvestmentOverview;